<template>
  <div class="server-card-wrapper" v-if="isShowRiderInfo">
    <div class="card-item">
      <img
        class="item-img"
        v-if="data.headPic"
        :src="data.headPic"
        v-http2
        v-img-size="'medium'"
        v-img-error
      />
      <div class="content-box">
        <p class="item-title ellipsis" v-text="data.name"></p>
        <p class="item-tag ellipsis" v-text="entregaTitle"></p>
      </div>
      <div class="mb-right-box">
        <p class="phone-btn" v-if="data.isOpenPhone" @click="callPhone()">
          <i class="icon-outline_phone"></i>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ServerCardEntrega',
  props: {
    data: Object,
    orderId: String,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      country: ({ common }) => common.country,
      orderStatus: ({ entrega }) => entrega.orderStatus,
    }),
    entregaTitle() {
      return this.country === 'BR' ? this.$t('Entrega_name_99_Flash_maAd') : this.$t('FoodC_presentation_DiDi_Delivery_vrwd');
    },
    isShowRiderInfo() {
      return JSON.stringify(this.data) == "{}" ? false : true;
    },
    sailing_c_e_landing_order_contact_rider_ck() {
      return {
        eventId: 'sailing_c_e_landing_order_contact_rider_ck',
        eventLabel: 'H5订单跟踪页点击联系骑手',
        attrs: {
          order_id: this.orderId,
          order_status: this.orderStatus
        }
      }
    }
  },
  mounted() {
  },
  methods: {
    callPhone() {
      this.$trackEvent(this.sailing_c_e_landing_order_contact_rider_ck);
      this.$virtualTel({
        orderId: this.orderId
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.server-card-wrapper {
  display: flex;
  overflow: hidden;
}
.card-item {
  position: relative;
  flex: 1;
  padding: 12px 10px;
  min-width: calc(50% - 5px);
  background: #fff;
  border-radius: 4px;
}

.card-item:nth-child(even) {
  margin-left: 10px;
}
.item-img {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border: 1px solid #EBEBEB;
  border-radius: 50%;
}
.content-box {
  float: right;
  width: calc(100% - 48px);
  font-size: 0;
}
.item-title {
  margin-bottom: 4px;
  height: 18px;
  line-height: 18px;
  font-family: 'Aspira Medium';
  font-weight: 500;
  font-size: 14px;
  color: #000000;
}

.item-tag {
  display: inline-block;
  padding: 0 4px;
  line-height: 16px;
  font-family: 'Aspira Medium';
  font-weight: 500;
  font-size: 12px;
  color: #000000;
  background: #e3e3e6;
  border-radius: 2px;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
  word-wrap: break-word;
}
.mb-right-box {
  display: none;
}
@media screen and (max-width: 768px) {
  .server-card-wrapper {
    white-space: nowrap;
    overflow-x: scroll;
  }
  .card-item {
    display: inline-block;
    margin-right: rem(18);
    padding: rem(50) rem(32);
    min-width: 88%;
    border-radius: rem(8);
    overflow: hidden;
  }
  .card-item:nth-child(even) {
    margin-left: 0;
  }
  .card-item:last-child {
    margin-right: 0;
  }
  .item-img {
    float: left;
    margin-right: rem(18);
    width: rem(88);
    height: rem(88);
  }

  .content-box {
    float: left;
    width: auto;
    max-width: 66%;
  }
  .item-title {
    margin-bottom: rem(2);
    height: rem(44);
    line-height: rem(44);
    font-size: rem(32);
  }
  .item-tag {
    padding: 0 rem(12);
    line-height: rem(36);
    font-size: rem(20);
    border-radius: rem(4);
  }
  .mb-right-box {
    display: block;
    float: right;
    margin-top: rem(20);
    font-size: rem(42);
  }
  .msg-btn,
  .phone-btn {
    display: inline-block;
    cursor: pointer;
  }
  .msg-btn {
    margin-left: rem(18);
    margin-right: rem(47);
  }
  .phone-btn {
    margin-left: rem(18);
  }
}
</style>
